import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getInisial } from '../../helpers';
import { generalConstants } from '../../constants';

class Header extends React.Component{

    render(){
      const { user, notification, setMode, miniMode, siteName } = this.props;
      return(
        <header className="main-header">

          <Link to={generalConstants.URL} className="logo">
            <span className={ (miniMode ? 'logo-mini' : 'logo-lg' ) }>{ (miniMode ? getInisial(siteName) : siteName ) }</span>
          </Link>
          
          <nav className="navbar navbar-static-top">
            
            <div>
              <button type="button" className="navbar-toggle" data-toggle="push-menu" onClick={ setMode } role="button">
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>

              <span className="nav-logo">{ siteName }</span>
            </div>

            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav" >

                {/*<li className="dropdown messages-menu">
                  <Link to="/" className="dropdown-toggle" data-toggle="dropdown">
                    <i className="fal fa-bell"></i>
                    { notification.data ? <span className="label label-success">{notification.data.length}</span> : <span/>}
                  </Link>
                  <ul className="dropdown-menu">
                    <li className="header">Notifications</li>
                    <li>
                      <ul className="menu">
                        {
                          notification.data ?
                        <li>
                          <Link to="#">
                            <h4>
                              { notification.data.title }
                            </h4>
                            <p>{ notification.data.description }</p>
                            <small>{ notification.data.time_publish }</small>
                          </Link>
                        </li>
                        :
                        <li>
                          <div className="message-empty">
                            You currently don't have any notification.
                          </div>
                        </li>

                        }
                      </ul>
                    </li>
                    <li className="footer"><Link to="/">See All Notifications</Link></li>
                  </ul>
                </li>*/}
                
                <li className="dropdown user user-menu">
                  <Link to="#" className="dropdown-toggle" data-toggle="dropdown">
                    <i className="fal fa-user"></i>
                    <span className="user-menu-text">{ user.accountName }</span>
                  </Link>
                  <div className="dropdown-menu">
                    {/*<Link className="dropdown-item" to="">Profile</Link>
                    <Link className="dropdown-item" to="">Accounts &amp; Security</Link>
                    <Link className="dropdown-item" to="">Notification</Link>*/}
                    <Link className="dropdown-item" to={generalConstants.URL+"login"}>Logout</Link>
                  </div>
                </li>

              </ul>
            </div>
          </nav>
        </header>
      );
    }
} 

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { user } = authentication;
    const { notification } = general;
    return {
        user,
        notification
    };
}

const connectedHeader = connect(mapStateToProps)(Header);
export { connectedHeader as Header };



// WEBPACK FOOTER //
// ./src/components/common/Header.jsx